<template>
    <div>
        <div class="c-comments__insert" v-if="$root.user !== false && $root.is_member > 0 && show">
            <img class="c-comments__img" :src="$root.user.avatar" alt="Commenting User">
            <div class="c-comments__box">
                <textarea v-model="comment" :class="['c-comments__input', showActions ? 'activeTextarea' : '']" :placeholder="placeholder" rows="1" @keyup="autosize" @paste="autosize" @click="showActionsBar"></textarea>
                <div class="comment-photo-uploaded" v-if="commentImage">
                    <img :src="commentImage" alt="">
                </div>
                <file-upload
                    extensions="gif,jpg,jpeg,png,webp"
                    accept="image/png,image/gif,image/jpeg,image/webp"
                    post-action="/post/comment-upload"
                    :data="commentData"
                    @input-filter="uploadInputFilter"
                    @input-file="uploadInputFile"
                    :name="'commentupload-' + uuid"
                    :ref="'commentupload-' + uuid">
                </file-upload>
                <div id="bar" :class="['c-comments__bar', showActions ? 'activeUpload' : '']">
                    <label :for="'commentupload-' + uuid">
                        <img src="/img/ui/icon-upload.svg" alt="Upload">
                    </label>
                    <div class="comment-image-progress" v-if="progressData">{{progressData}}</div>
<!--                    <input id="js-image-upload" type="file" name="qqfile" ref="file" style="display: none" @change="uploadPhoto()">
                    <a id="js-comment-image-upload-btn" href="#" v-on:click.prevent="chooseFile"><img src="/img/ui/icon-upload.svg" alt="Upload"></a>
                    <a id="js-comment-image-upload-remove" href="#" v-on:click.prevent="removeFile" style="display: none;">X Remove media</a>
                    <input type="hidden" id="comment-photo-path" value="" />-->
                    <button id="saveComment" type="button" class="c-btn c-btn--blue" @click.prevent="save" :disabled="saveDisabled">
                        <img src="/img/ui/icon-post.svg" alt="Post" height="17" width="17">
                        <p>Post</p>
                    </button>
                </div>
            </div>
        </div>
        <div class="c-comments__insert" v-else-if="$root.user !== false && show">
            <img class="c-comments__img" :src="$root.user.avatar" alt="Commenting User">
            <div class="c-comments__box" @click.prevent="triggerJoinCommunity">
                <textarea class="c-comments__input" :placeholder="placeholder" rows="1" disabled></textarea>
            </div>
        </div>
        <div class="c-comments__insert" v-else-if="show">
            <img class="c-comments__img" src="/img/avatar-default.svg" alt="Commenting User">
            <div class="c-comments__box" @click.prevent="showMemberPanel">
                <textarea class="c-comments__input" :placeholder="placeholder" rows="1" disabled></textarea>
            </div>
        </div>
    </div>
</template>

<script>
import VueUploadComponent from 'vue-upload-component';
import { uuid } from 'vue-uuid';

export default {
    components: {
        FileUpload: VueUploadComponent
    },
    props: {
        parentId: Number
    },
    data() {
        return {
            placeholder: "Join the discussion...",
            mentions: [],
            showActions: false,
            commentData: {},
            progressData: '',
            commentImage: null,
            comment: '',
            saveDisabled: true,
            show: true,
            uuid: uuid.v1(),
        }
    },
    created() {
        // append postId to upload data if it exists to allow for contextual file naming
        if (typeof this.$root.post_id != 'undefined') {
            this.commentData.postId = this.$root.post_id;
        }
    },
    mounted() {

    },
    methods: {
        deleteCommentPhoto() {
            this.$http.post('/post/comment-remove-image', { image: this.commentImage })
                .then(response => {
                    this.commentImage = null;
                }, response => {
                    console.log('Errored:');
                    console.log(response);
                });
        },
        uploadInputFile(newFile, oldFile, prevent) {
            // cancel button pressed
            if (!newFile && oldFile) {

            }
            // file updating
            if (newFile && oldFile) {
                if (newFile.active && newFile.progress == 0) {
                    //this.heroStyle = 'filter: blur(10px)';
                    this.progressData = '0% uploaded';
                }
                if (this.beforeUploadStatus == null) {
                    this.beforeUploadStatus = this.showHeroUpload;
                }
                if (newFile.progress !== oldFile.progress) {
                    if (newFile.progress < 100) {
                        //let blur = Math.ceil((100 - newFile.progress) / 10) + 'px';
                        //this.heroStyle = 'filter: blur(' + blur + ')';
                        this.progressData = Math.ceil(newFile.progress) + '% uploaded';
                    } else {
                        this.progressData = '';
                    }
                }
                // file successfully uploaded
                if (newFile.success && !oldFile.success) {
                    //this.showHeroUpload = this.beforeUploadStatus;
                    //this.beforeUploadStatus = null;
                    this.commentImage = newFile.response.file;
                    //this.$root.$emit('save-post');
                }
            }
            // automatically upload files
            if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                if (!this.$refs['commentupload-' + this.uuid].active) {
                    // remove existing hero
                    if (this.commentImage != null) {
                        this.deleteCommentPhoto();
                    }
                    this.$refs['commentupload-' + this.uuid].active = true
                }
            }
        },
        uploadInputFilter(newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
                    alert('WARNING: You can only upload images files');
                    return prevent();
                }
            }
            if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
                newFile.url = '';
                let URL = window.URL || window.webkitURL;
                if (URL && URL.createObjectURL) {
                    newFile.url = URL.createObjectURL(newFile.file);
                    console.log(newFile);
                    //TODO: check size newFile.size is not too big before upload
                }
            }
        },
        showActionsBar() {
            this.showActions = true;
        },
        showMemberPanel() {
            this.$simpleStore.showMemberPanel(this);
        },
        triggerJoinCommunity() {
            let data = {
                message: this.$root.user.firstName + ', you cannot contribute content to the ' + this.$root.community.name + ' Community unless you are a member.',
                communityId: this.$root.community.id,
                communityThumbnail: this.$root.community.thumbnail
            }
            this.$root.$emit('show-community-modal', data);
        },
        autosize(event) {
            event.target.style.cssText = 'height:' + event.target.scrollHeight + 'px';
            if (event.target.value.length === 0) {
                this.showActions = false;
                this.saveDisabled = true;
            } else {
                this.showActions = true;
                this.saveDisabled = false;
            }
        },
        pushUniqueMentions() {
            let id = 1;
            let name = 'josh';
            if (!this.v1obj.hasOwnProperty(id)) {
                this.v1obj[id] = name
            }
        },
        save() {
            let commentData = {
                dyadey_id: this.$root.dyadey_id,
                parent_id: typeof this.parentId != 'undefined' ? this.parentId : null,
                comment: this.comment,
                image: this.commentImage
            };
            this.$http.post('/post/save-comment', commentData)
                .then(response => {
                    // add comment to this.$root.comments array - is reactive is the PostCommentsBlock component so should then display without a reload
                    if (typeof this.parentId == 'undefined') {
                        this.$root.comments.unshift(response.data.comment);
                        this.$root.$emit('unshift-comment', response.data.comment);
                        this.$root.$emit('update-comment-count');
                        this.$root.$emit('update-icon-comment-count');
                    } else {
                        this.$root.$emit('unshift-child-comment', { comment: response.data.comment, parentId: parseInt(commentData.parent_id) });
                        this.$root.$emit('show-child-comments');
                    }
                    this.showActions = false;
                    this.comment = '';
                    this.commentImage = null;
                    console.log('parentId', typeof this.parentId);
                    if (typeof this.parentId != 'undefined') {
                        this.show = false;
                        console.log('show false');
                    }
                }, response => {
                    console.log('Errored:');
                    console.log(response);
                });
        }
    }
}
</script>
